export class Account {
  email: string;
  password: string;

  constructor() {
    this.email = '';
    this.password = '';
  }
}
